export * from './dropdown/search-filter.pipe';
export * from './dropdown/dropdown.module';
export * from './dropdown/dropdown.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-2-dropdown-multiselect/index.js
// module id = 1057
// module chunks = 12